import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars-2";
import Axios from "axios";
import "./Checkout.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckLg } from "react-icons/bs";
import { ClearCart } from "../components/Redux/Action";
import { useNavigate } from "react-router-dom";
import Orderhistory from "./Orderhistory";
import Getlocation from "./Getlocation";
import { BsChevronRight } from "react-icons/bs";
import { IoMdCall } from "react-icons/io";
import { FaUserTie } from "react-icons/fa";
import { MdArrowDropDownCircle, MdOutgoingMail } from "react-icons/md";
import { AiFillHome } from "react-icons/ai";
import { RiTimerFill } from "react-icons/ri";
import { SiGooglemaps } from "react-icons/si";
import { ClipLoader } from "react-spinners";

const Checkout = () => {
  const cartItems = useSelector((state) => state.Reducer);
  const lodinndata = useSelector((state) => state.LoginData);

  const lodinName = lodinndata.partyName;
  const lodinNumber = lodinndata.mobile;
  const lodinEmail = lodinndata.email;

  const dispatch = useDispatch();
  const lengthItem = cartItems.length;
  const [ordernumber, setOrdernumber] = useState(null);
  const navigate = useNavigate();
  const [orderhistory, setOrderhistory] = useState();

  const [getlocation1, setGetlocation1] = useState(false);
  const [cityD, setCityD] = useState("Select City");
  const [cityM, setCityM] = useState(false);
  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [email, setEmail] = useState("");
  const [adress, setAdress] = useState("");
  const [date, setDate] = useState("");
  const [delivery, setDelivery] = useState("");
  const [deliveryaddress, setDeliveryaddress] = useState("");
  const [checkboxx, setCheckboxx] = useState(false);
  const [checkOutLoader, setChecOutLoader] = useState(false);
  const [checkOutPassed, setChecOutPassed] = useState(false);
  const [OrderNo, setOrderNo] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountTitle, setAccountTitle] = useState("");
  const [accountNumberText, setAccountNumberText] = useState("");
  const dropdown = [
    {
      name: "CHICHAWATNI",
      id: "0001",
    },
    {
      name: "MIAN CHANNU",
      id: "0002",
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    e.target.reset();
  };

  useEffect(() => {
    // Set the default value to today's date in the format 'YYYY-MM-DD'
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // Get the date in 'YYYY-MM-DD' format
    setDate(today);
  }, []);
  function DateTimeFarmate(d) {
    let dateC = d.split(",")[0].split("/");
    let timec = d.split(",")[1].split(" ")[1];
    let hh = timec.split(":")[0];
    let minut = timec.split(":")[1];
    let dp = d.indexOf("AM");

    let month =
      +dateC[0].toString().length == 1
        ? "0" + dateC[0].toString()
        : dateC[0].toString();
    let day =
      +dateC[1].toString().length == 1
        ? "0" + dateC[1].toString()
        : dateC[1].toString();
    //  let formDated= dateC[2].toString()+"-"+ month + "-" + day+"T"+ (hh?.length>1? hh.toString():( "0" + hh.toString() ) )+":"+  (minut?.length>1? minut.toString():( "0" + minut.toString() ) ) +":00.002Z"
    let formDated;

    if (dp != -1) {
      formDated =
        dateC[2].toString() +
        "-" +
        month +
        "-" +
        day +
        "T" +
        (hh?.length > 1 ? hh.toString() : "0" + hh.toString()) +
        ":" +
        (minut?.length > 1 ? minut.toString() : "0" + minut.toString()) +
        ":00.002Z";
    } else {
      formDated =
        dateC[2].toString() +
        "-" +
        month +
        "-" +
        day +
        "T" +
        (+hh + 12).toString() +
        ":" +
        (minut?.length > 1 ? minut.toString() : "0" + minut.toString()) +
        ":00.002Z";
    }
    return formDated;
  }

  // useEffect(() =>{
  //     var showdate = new Date();
  //     let hrs = showdate.getHours();
  //     let mint = showdate.getMinutes();
  //     let secn = showdate.getSeconds();
  //     let min = mint < 10 ? `0${mint}` : mint;
  //     const currTime = hrs > 12 ? `0${hrs - 12}:${min} ` : `${hrs}:${min} `;
  //     var displaydate =showdate.getFullYear()+'-'+"0"+(showdate.getMonth()+1)+'-'+showdate.getDate()+"T"+currTime;
  //     setCurrent(displaydate)
  //     // console.log(" Current Data "+ " " +displaydate)
  //     // console.log(current);
  // })

  // const disableDate = () =>{
  //     var today, dd, mm, yyyy,
  //     today = new Date();
  //     dd = today.getDate()+1 ;
  //     mm = today.getMonth()+1;
  //     yyyy = today.getFullYear();
  //     let alldate = yyyy+"-"+"0"+mm+"-"+dd;
  //     // console.log(alldate)
  // }

  // useEffect(() =>{
  //     disableDate()
  // })

  // Open Modal with Content
  const openModal = (content, accountNumber, accountText) => {
    setModalContent(content);
    setAccountNumber(accountNumber);
    setAccountNumberText(accountText);
    setAccountTitle("Super Duper");
    setIsModalOpen(true);
  };

  // Close Modal
  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent("");
  };
  const checkoutapi = async () => {
    setChecOutLoader(true);

    let flag = true;
    let toastMessage = null;
    let latitude = window.latitude;
    let longitude = window.longitude;

    if (name.length < 3) {
      toastMessage = "Name is required";
    } else if (number.length < 11) {
      toastMessage = "Number is required";
    } else if (!cityD || cityD === "Select City") {
      toastMessage = "City is required";
    } else if (adress.length < 1) {
      toastMessage = "Address is required";
    } else if (checkboxx === false) {
      toastMessage = "Please accept Terms & Conditions";
    }

    if (toastMessage) {
      toast.warn(toastMessage, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setChecOutLoader(false);
      return;
    }

    flag = false;

    const sendData = cartItems.map((item) => ({
      hsCode: "",
      description: item.description,
      hsPercentage: 0.0,
      barcode: item.barcode,
      qty: item.qty,
      unitCost: item.unitCost,
      unitRetail: item.unitRetail,
      amount: +item.unitRetail * +item.qty,
      productImage: `${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`,
    }));

    const currentDate = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Karachi",
    });
    const dt = DateTimeFarmate(currentDate);

    try {
      const response = await Axios.post(
        `${window.sbapi}/api/Sale/CheckoutEcom`,
        {
          DocType: "2",
          DocDate: dt,
          SaleType: "WebStore",
          PartyMobile: number,
          PartyName: name,
          PartyAddress: adress,
          PartyCity: cityD === "CHICHAWATNI" ? "0001" : "0002",
          PartyCityName: cityD,
          PartyEmail: email,
          TotalDiscountAmount: discount - total,
          TotalAmount: total,
          LocId: "000001",
          UserId: "0000000001",
          BusinessId: "0000000001",
          description: delivery ?? "",
          Longitude: longitude ?? "",
          Latitude: latitude ?? "",
          DeliveryAddress: deliveryaddress,
          DocumentDetail: sendData,
        }
      );

      const resData = response?.data;

      if (resData?.code === 200 && resData?.data?.docNo) {
        toast.success("Your order was successfully completed!", {
          position: "top-center",
          autoClose: 1000,
        });
        setChecOutLoader(false);
        setOrderhistory(sendData);
        setChecOutPassed(true);
        setOrderNo(response);
        dispatch(ClearCart());
      } else {
        toast.error(
          "Order submitted but encountered a problem. Check email status.",
          {
            position: "top-center",
          }
        );
        setChecOutLoader(false);
      }
    } catch (error) {
      console.log("Checkout API Error ----->", error);
      toast.error("Network or server error. Please try again.", {
        position: "top-center",
      });
      setChecOutLoader(false);
    }
  };

  let total = 0;
  cartItems.map((item) => {
    let d = item.promoPercentage
      ? Math.round(
          item.unitRetail - (item.unitRetail * item.promoPercentage) / 100
        )
      : item.unitRetail;
    total = total + d * item.qty;
  });

  let discount = 0;
  cartItems.map((item) => {
    // let d=item.promoPercentage ? item.unitRetail - (item.unitRetail * item.promoPercentage / 100) : item.unitRetail
    discount = discount + item.unitRetail * item.qty;
  });

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="colored"
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Header />
      {!checkOutPassed ? (
        <div className="all-checkout">
          <div className="forms">
            <div className="forms-a">
              <h1>SHIPPING INFORMATION</h1>
            </div>
            <form className="forms-b" onSubmit={handleSubmit}>
              <div className="form-input">
                <span className="inpute-icons">
                  <FaUserTie size={20} />
                </span>
                <input
                  type="text"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Name"
                />
              </div>
              <div className="form-input">
                <span className="inpute-icons">
                  <IoMdCall size={20} />
                </span>
                <input
                  maxLength={11}
                  type="tel"
                  value={number}
                  onChange={(e) => setNumber(e.target.value)}
                  placeholder="Number"
                />
              </div>

              <div className="form-input">
                <span className="inpute-icons">
                  <MdOutgoingMail size={20} />
                </span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-mail"
                />
              </div>

              <div className="form-input">
                {/* The Select dropdown */}
                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "25px",
                    height: "200%",
                    width: "100%",
                    display: "flex",
                  }}
                >
                  <select
                    required
                    value={cityD}
                    onChange={(e) => setCityD(e.target.value)}
                    style={{
                      cursor: "pointer",
                      border: "none",
                      background: "white",
                      outline: "none",
                      fontSize: "16px",
                      padding: "16px",
                      width: "100%",
                      borderRadius: "25px",
                      fontFamily: "Arial, sans-serif",
                    }}
                  >
                    <option value="">Select City</option>
                    {dropdown?.map((itm, k) => (
                      <option key={k} value={itm.name}>
                        {itm.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-input">
                <span className="inpute-icons">
                  <AiFillHome size={20} />
                </span>
                <input
                  type="text"
                  value={adress}
                  onChange={(e) => setAdress(e.target.value)}
                  placeholder="Address"
                />
              </div>
              <div className="form-input" style={{ display: "none" }}>
                <span className="inpute-icons">
                  <RiTimerFill size={20} />
                </span>
                <input type={"date"} value={date} placeholder="" />
                {/* <input type={"date"}  min={"2022-06-24"} max="2022-06-25" value={date} onChange={e => setDate(e.target.value)} placeholder="" />*/}
              </div>
              {/* <div className="form-input">
                <span className="inpute-icons" ><SiGooglemaps size={20} /></span>
                <input type="text" value={window.sendaddress} onChange={e => setDeliveryaddress(e.target.value)} onClick={() => setGetlocation1(!getlocation1)} placeholder="Get Location" style={{ cursor: "pointer" }} />
                <span style={{ position: "absolute", top: "50", right: "10px", cursor: "pointer" }}><BsChevronRight size={20} /></span>

                <span className='mapstyle1'  >
                    <span className='mapstyle' style={{ display: getlocation1 ? 'flex' : 'none' }}  >
                        <Getlocation closeMap={setGetlocation1} />
                    </span>
                </span>
            </div> */}

              <textarea
                value={delivery}
                onChange={(e) => setDelivery(e.target.value)}
                placeholder="Comments"
              />
            </form>
          </div>
          <div className="order-review">
            <div className="forms-a">
              <h1>ORDER REVIEW</h1>
            </div>
            <div className="forms-c">
              <div className="pro">
                <div className="pro1 ">
                  <span className="left-div"> PRODUCT </span>
                  <span className="right-div"> PRICE </span>
                </div>

                <div className="pro2">
                  <Scrollbars
                    autoHeight
                    autoHeightMin={0}
                    autoHeightMax={200}
                    style={{ position: "relative" }}
                  >
                    <div style={{ padding: 20, paddingBottom: 0 }}>
                      {cartItems.map((item) => {
                        return (
                          <div className="pro2_inner">
                            <span className="left-div">
                              {" "}
                              ({item.qty}) x {item.description}
                            </span>
                            <span className="right-div">
                              {" "}
                              Rs.
                              {item.promoPercentage
                                ? Math.round(
                                    item.unitRetail -
                                      (item.unitRetail * item.promoPercentage) /
                                        100
                                  ) * item.qty
                                : item.unitRetail * item.qty}{" "}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </Scrollbars>

                  {console.log("----   date and time -------------> ", date)}

                  {/* <div className="pro2_inner" style={{ paddingTop: 10, paddingLeft: 20, paddingRight: 20 }}>
                        <span className="left-div">Delivery Charges</span>
                        <span className="right-div">Rs. 0</span>
                    </div> */}

                  {discount - total == 0 ? null : (
                    <div
                      className="pro2_inner"
                      style={{ paddingLeft: 20, paddingRight: 20 }}
                    >
                      <span className="left-div">Discount</span>
                      <span className="right-div">{discount - total}</span>
                    </div>
                  )}
                </div>

                <div className="pro3">
                  <span className="left-div"> TOTAL </span>
                  <span className="right-div">
                    {" "}
                    Rs.<span style={{ fontSize: 24 }}>{total}</span>
                  </span>
                </div>
              </div>

              <div
                style={{
                  height: "30px",
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "rgb(0,90,181)",
                  borderRadius: 5,
                }}
              >
                <p style={{ color: "white" }}>
                  {" "}
                  Delivery Charges will be calculated as per distance
                </p>
              </div>
              <div className="text">
                <a
                  onClick={() => setCheckboxx(!checkboxx)}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 15,
                    width: 15,
                    border: "1px solid black",
                    backgroundColor: checkboxx ? "#038eff" : "white",
                    marginRight: 10,
                  }}
                >
                  <BsCheckLg color="white" />
                </a>
                <p>
                  I've read and accept the{" "}
                  <Link className="checkboclinks" to={"/termcondition"}>
                    Terms Conditions
                  </Link>
                  &nbsp;and&nbsp;
                  <Link className="checkboclinks" to={"/privacypolicy"}>
                    Privacy Policy
                  </Link>
                </p>
              </div>
              <div>
                {/* Buttons */}
                <div className="button-row">
                  <button className="cod-btn">Cash on Delivery</button>
                  <button
                    className="bank-btn"
                    onClick={() =>
                      openModal(
                        "Bank Alfalah",
                        "01161006171493",
                        "Account Number"
                      )
                    }
                  >
                    Bank
                  </button>
                  <button
                    className="jazz-cash-btn"
                    onClick={() =>
                      openModal("Jazz Cash", "980073149", "Till ID")
                    }
                  >
                    Jazz Cash
                  </button>
                </div>

                {/* Modal */}
                {isModalOpen && (
                  <div className="modal-overlay">
                    <div className="modal">
                      <h1>Payment Transfer Details</h1>
                      <br />
                      <br />
                      <div className="modal-body">
                        <p className="modal-text">
                          <span className="modal-text-title">Bank Name</span> :{" "}
                          <span style={{ color: "red" }}>{modalContent}</span>
                        </p>
                        <p className="modal-text">
                          <span className="modal-text-title">
                            Account Title
                          </span>{" "}
                          :{" "}
                          <span className="account-title">{accountTitle}</span>
                        </p>
                        <p className="modal-text">
                          <span className="modal-text-title">
                            {accountNumberText}
                          </span>{" "}
                          : {accountNumber}
                        </p>
                      </div>
                      <div className="modal-footer">
                        <button className="close-btn" onClick={closeModal}>
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="place-order">
                <button disabled={checkOutLoader} onClick={checkoutapi}>
                  {checkOutLoader ? (
                    <ClipLoader color={"red"} loading={true} size={30} />
                  ) : (
                    <p> PLACE ORDER </p>
                  )}
                </button>
              </div>
              <div className="btns2">
                <div className="cart-btn">
                  <Link to={"/viewcart"}>
                    {" "}
                    <button style={{ padding: "10px 50px" }}>
                      <p> VIEW CART </p>
                    </button>
                  </Link>
                </div>
                <div className="shop-btn">
                  <Link to={"/"}>
                    <button>
                      <p> CONTINUE SHOPPING </p>
                    </button>{" "}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            border: "1px solid",
            alignItems: "center",
            flexDirection: "column",
            height: "400px",
          }}
        >
          <div
            style={{
              height: "50%",
              justifyContent: "center",
              margin: "10px",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <h1 style={{ color: "#005ab5", margin: "10px" }}>
              Your Order is submited successfully.
            </h1>
            <h1 style={{ color: "#005ab5", margin: "10px" }}>Tracking order</h1>
            <div style={{ color: "black", fontSize: "18px" }}>
              {OrderNo?.data?.data?.docNo}
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#005ab5",
              display: "flex",

              height: "50px",

              width: "200px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "10px",
            }}
          >
            <Link to={"/"}>
              <button style={{ backgroundColor: "#005ab5", border: "0px" }}>
                {checkOutLoader ? (
                  <ClipLoader color={"red"} loading={true} size={30} />
                ) : (
                  <p style={{ color: "white" }}> Home </p>
                )}
              </button>
            </Link>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Checkout;
